import axios from '@/assets/js/api';
import {requestUrlConfig } from '@/assets/js/httpRequest/reqUrlConfig'

// 获取部门列表数据
export const getDepartmentList = () => {
    return axios.request({
        url: requestUrlConfig.getDepartmentList,
        method: 'get',
    })
}
// 获取部门评分表模板列表数据
export const getFromTempList = () => {
    return axios.request({
        url: requestUrlConfig.getFormTempList,
        method: 'get',
    })
}
export const createFromTemp = ({department_id,template_name}) => {
    return axios.request({
        url: requestUrlConfig.createFormTemp,
        data: {
            department_id,template_name
        },
        method: 'post',
    })
}
export const deleteFromTemp = ({template_id}) => {
    return axios.request({
        url: requestUrlConfig.deleteFormTemp,
        params: {
            template_id
        },
        method: 'DELETE',
    })
}